import React, {useState} from 'react';
import { ContainerCoverVideo, Container, TitleSub, HeaderSdg, ContainerChart, Subtitle } from '../../components/AppComponents';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import highchartsMore from 'highcharts/highcharts-more'; 
import highchartsGroupedCategories from 'highcharts-grouped-categories';

import { figure67 } from '../../graphs/es/figure67';
import { figure70 } from '../../graphs/es/figure70';
import { figure71 } from '../../graphs/es/figure71';
import { figure74 } from '../../graphs/es/figure74';
import { figure75 } from '../../graphs/es/figure75';
import { figure76 } from '../../graphs/es/figure76';
import { figure81 } from '../../graphs/es/figure81';
import Modal from "../../components/Modal";

// import { figure55 } from '../graphs/es/figure55';
// eslint-disable-next-line
highchartsMore(Highcharts);
highchartsGroupedCategories(Highcharts);

const Sdg15 = () => {
    const [open, setOpen] = useState(false);
    const [text, setText] = useState(false);

    const handleClickOpen = (value) => {
        setOpen(true);
        setText(value);
    };

    const handleClose = (value) => {
        setOpen(false);
        setText(value);
    };
    return (
      
        <React.Fragment>
            <Modal
                text={text}
                open={open}
                onClose={handleClose}
            />
            <ContainerCoverVideo 
                id="15"
                poster={require('../../images/poster-sdg-15.png').default}
                video={require('../../images/video-sdg-15.mp4').default}
                sdgImage={require('../../images/EN_15.svg').default}
                sdg="OBJETIVO DE DESARROLLO SOSTENIBLE 15"
                title="Vida de ecosistemas terrestres"
                subtitle="Gestionar sosteniblemente los bosques, luchar contra la desertificación, detener e invertir la degradación de las tierras y detener la pérdida de biodiversidad."
                summaryTable={require('../../images/Goal_15.zip').default}
                indicators={['15.1.1', '15.2.1', '15.3.1', '15.4.2', '15.6.1']}  
                indicatorsTitle="INDICADORES"
                summaryTableTitle= "TABLAS DE RESUMEN"
            />

            <Container>
                <TitleSub title="Visión general" />
<p>El mundo se enfrenta a una triple crisis planetaria de cambio climático, contaminación y pérdida de biodiversidad. La tendencia a la pérdida de bosques, la degradación de la tierra y la extinción de especies se está agravando, lo que supone una grave amenaza para la salud del planeta y de las personas. La superficie forestal total del mundo ha disminuido en 100 millones de hectáreas desde el año 2000, aunque el ritmo de pérdida de bosques parece haber disminuido en los últimos años. Además, entre 2015 y 2019, el mundo ha estado perdiendo al menos 100 millones de hectáreas de tierra sana y productiva cada año. Si bien la cubierta vegetal de las zonas montañosas se ha mantenido aproximadamente estable en torno al 78 % durante el periodo 2000-2018, los datos disponibles a escala mundial indican que la proporción de la superficie montañosa degradada se sitúa en el 1,6 % de la superficie montañosa total del mundo durante el mismo periodo. Hay indicios alentadores de que la adopción de prácticas de gestión forestal sostenible ha mejorado en el último decenio. Mientras tanto, un número creciente de países está adoptando medidas para facilitar el intercambio de material fitogenético con el fin de promover el acceso y la distribución de beneficios.</p>
<div id="section15.1.1">
                    <HeaderSdg 
                        title="INDICADOR 15.1.1 DE LOS ODS"
                        subtitle="Superficie forestal en proporción a la superficie total"
                        badges={[
                            {color: '#ffff05', text: 'Evaluación de la situación mundial: en la mediana de los valores nacionales.'},
                            { color: '#ff6261', text: 'Evaluación de la tendencia mundial: deterioro.'},
                        ]}
                        target={{
                            sdg: "15",
                            title: 'Meta 15.1',
                            text: 'De aquí a 2020, asegurar la conservación, el restablecimiento y el uso sostenible de los ecosistemas terrestres y los ecosistemas interiores de agua dulce y sus servicios, en particular los bosques, los humedales, las montañas y las zonas áridas, en consonancia con las obligaciones contraídas en virtud de acuerdos internacionales.'
                        }}
                    />
                </div>

<p><b>En 2020, los bosques cubrían el 31,2 % de la superficie terrestre total, lo que refleja un descenso de 100 millones de hectáreas en el transcurso de los dos últimos decenios.</b></p>
<p>La proporción de la superficie terrestre total del mundo que está cubierta por bosques ha disminuido gradualmente del 31,9 % en el año 2000 (4 200 millones de hectáreas) hasta el 31,5 % en 2010, para posteriormente bajar al 31,2 % (4 100 millones de hectáreas) en 2020 (Figura 67). Desde la puesta en marcha de la Agenda 2030 en 2015, la cubierta forestal ha experimentado a nivel mundial un descenso del 0,2 %, equivalente a casi 25 millones de hectáreas. Esto representa aproximadamente una cuarta parte de las pérdidas netas de superficie forestal de cerca de 100 millones de hectáreas en los dos últimos decenios.</p>
<p>Esta tendencia mundial deriva de dinámicas regionales opuestas. Europa, América septentrional y la mayoría de las regiones de Asia registraron un aumento global de la superficie forestal entre 2000 y 2020 debido a la forestación, los esfuerzos de restauración del paisaje y la expansión natural de los bosques (Figura 67). En concreto, la superficie forestal aumentó en Asia oriental un 3,64 %, mientras que Asia sudoriental experimentó un descenso del 3,65 % en este periodo. Sin embargo, la expansión de la superficie forestal se ralentizó entre 2010 y 2020 en comparación con el período 2000-2010.</p>
<p>Por el contrario, en los últimos 20 años se han producido grandes pérdidas de superficie forestal en América Latina y el África subsahariana. En particular, los PMA se ven afectados por la pérdida de superficie forestal. Mientras que en América Latina la deforestación se debe a la conversión de los bosques en pastizales para el ganado, en el África subsahariana el factor directo más común es la expansión de las tierras de cultivo. La expansión agrícola es el generador directo de casi el 90 % de la deforestación mundial. La expansión de las tierras de cultivo fue el generador directo más importante (49,6 %), seguido del pastoreo de ganado (38,5 %). Solamente las palmas aceiteras representaron el 7 % de la deforestación mundial en el periodo comprendido entre 2000 y 2018.</p>
<p>Los bosques desempeñan una importante función para los medios de vida y el bienestar de las poblaciones rurales y urbanas. Estos contribuyen especialmente a regular el ciclo del agua, mitigar el cambio climático y albergar a la mayoría de la biodiversidad terrestre del planeta. La pérdida de bosques altera la dinámica de los ecosistemas, con efectos generalizados sobre el clima, las interacciones entre los seres humanos y la fauna silvestre, las interrelaciones entre las actividades de uso de la tierra y la prestación de servicios ecosistémicos.</p>
<p>Aunque aún no se han medido los efectos a corto y largo plazo de la crisis de la COVID-19 sobre la superficie forestal, la pandemia ha tenido repercusiones directas sobre la cubierta forestal y la silvicultura debido a los cambios en el flujo de población entre las zonas urbanas y rurales y a la demanda adicional de determinados productos forestales. Muchas zonas rurales, sobre todo en los trópicos, se enfrentan a la creciente presión de la deforestación, la explotación ilegal de madera y la caza furtiva.</p>
<p>Mantener el impulso para detener la deforestación y la degradación de los bosques, y restaurar los ecosistemas dañados, es crucial para mejorar la resiliencia climática de los ecosistemas, evitar las pérdidas de biodiversidad y mejorar los medios de vida rurales, especialmente en los trópicos y los PMA.</p>
	    </Container>
	                <ContainerChart
                title="Figura 67. Superficie forestal como proporción de la superficie total, porcentaje (2000, 2010, 2015 y 2020)"
                legend={[
                    {title: '2000', color: '#70ad47'},
                    {title: '2010', color: '#a9d18e'},
                    {title: '2015', color: '#e2f0d9'},
                    {title: '2020', color: '#385723'},
                ]}
			 note={<span><b>Fuente:</b> FAO. 2023. Datos. En: <i>Portal de datos de indicadores de los ODS</i>. Roma. [Consultado el 8 de junio de 2023]. <a href="https://www.fao.org/sustainable-development-goals-data-portal/data/es">https://www.fao.org/sustainable-development-goals-data-portal/data/es</a><br/><a href="https://doi.org/10.4060/CC7088EN-fig67" download>https://doi.org/10.4060/CC7088EN-fig67</a></span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure67}
                />
            </ContainerChart>

            {/* Interactive Map  */}
            <ContainerChart
                title="Figura 68. Tendencia de la superficie forestal como porcentaje de la superficie total (2015-2020)"
                legend={[
                    {title: 'Mejora', color: '#00a700'},
                    {title: 'Mejora leve o ninguna', color: '#2acb2a'},
		    {title: 'Ligero deterioro', color: '#ffa500'},
		    {title: 'Deterioro', color: '#ff0000'},
		    {title: 'Datos insuficientes', color: '#808080'},
                ]}
                source={<span><b>Fuente:</b> FAO. 2023. Datos. En: <i>Portal de datos de indicadores de los ODS</i>. Roma. [Consultado el 8 de junio de 2023]. <a href="https://www.fao.org/sustainable-development-goals-data-portal/data/es">https://www.fao.org/sustainable-development-goals-data-portal/data/es</a>  (modificado para ajustarse a lo dispuesto en la Sección de Información Geoespacial de las Naciones Unidas, 2023).<br/></span>}
                note={<span>Nota: La línea de puntos representa aproximadamente la línea de control de Jammu y Kashmir acordada por la India y el Pakistán. El estatuto final de Jammu y Kashmir todavía no ha sido acordado por las partes. La frontera definitiva entre la República del Sudán y la República de Sudán del Sur todavía no se ha determinado.<br/>Todavía no se ha determinado el estatuto definitive de la zona de Abyei. Existe una disputa entre los Gobiernos de la Argentina y el Reino Unido de Gran Bretaña e Irlanda del Norte acerca de la soberanía sobre las Islas Malvinas (Falkland Islands).</span>}>
                <iframe loading='lazy' className='chart-container-image' style={{border: 'none'}} title='map68' src="fig68.html" width='100%'  height='500px'/>

            </ContainerChart>

            <Container>
                <div id="section15.2.1">
                    <HeaderSdg 
                        title="INDICADOR 15.2.1 DE LOS ODS"
                        subtitle="Progresos hacia la gestión forestal sostenible"
                        badges={[
                            {color: '#cecece', text: 'Evaluación de la situación mundial: no realizada por motivos metodológicos.'},
                            {color: '#cecece', text: 'Evaluación de la tendencia mundial: no realizada por motivos metodológicos.'},
                        ]}
                        target={{
                            sdg: "15",
                            title: 'Meta 15.2',
                            text: 'De aquí a 2020, promover la puesta en práctica de la gestión sostenible de todos los tipos de bosques, detener la deforestación, recuperar los bosques degradados y aumentar considerablemente la forestación y la reforestación a nivel mundial.'
                        }}
                    />
                </div>

<p><b>El mundo avanza hacia la gestión forestal sostenible, pero el ritmo de pérdida de bosques sigue siendo elevado.</b></p>
<p>Aunque en el último decenio se han registrado algunos progresos hacia la gestión forestal sostenible en todo el mundo, los progresos son desiguales en las distintas regiones. Además, los bosques del mundo siguen reduciéndose, principalmente debido a la expansión de la agricultura para la producción agrícola y ganadera.</p>
<p>En 2022, 444 millones de hectáreas de bosque estaban bajo un sistema de certificación (Figura 70). La superficie forestal certificada registró un aumento del 29 %, equivalente a unos 100 millones de hectáreas desde 2010. Esta tendencia positiva se observa principalmente en Europa y América septentrional, donde se certificaron 65 millones de hectáreas en 2010-2022. Sin embargo, los últimos datos muestran que la superficie forestal certificada disminuyó en 19 millones de hectáreas (4 %) entre 2021 y 2022.</p>
<p>La proporción de superficie forestal en zonas protegidas aumentó en todo el mundo del 17 % al 18 % entre 2010 y 2020. En 2020, la subregión con mayor proporción de bosques en zonas protegidas fue Asia central (59 %). La misma región registró el mayor aumento relativo de 2010 a 2020 (12 %). Europa y América septentrional presentan la proporción más baja, con solo un 6 % de sus bosques dentro de zonas protegidas.</p>
<p>La superficie forestal sometida a un plan de gestión aumentó de 2010 a 2020. La mayoría de los bosques de Europa y Asia son objeto de un plan de gestión, y se registran grandes aumentos en especial desde 2010 en Asia central y Asia oriental. La proporción de bosques objeto de planes de gestión sigue siendo inferior a un tercio, aunque aumenta lentamente, en América Latina y el Caribe, Oceanía y el África subsahariana.</p>
<p>La cantidad de biomasa por encima del suelo en los bosques ha aumentado ligeramente debido a su notable incremento en Asia oriental, Europa y Asia occidental.</p>
<p>La tasa anual de cambio forestal se mantiene relativamente estable a nivel mundial (en torno al -0,1 %), lo que indica que, aunque la pérdida de bosques continúa, lo hace a un ritmo ligeramente menor. La expansión de los bosques se observó en Asia, Europa y América septentrional entre 2010-2020, mientras que se registraron importantes pérdidas de bosques en África, Asia sudoriental, así como en América Latina y el Caribe. Estas pérdidas obedecen principalmente a la expansión de la agricultura. La deforestación y la degradación de los bosques siguen constituyendo un gran desafío, especialmente en los trópicos, los PMA, los PDL y los PEID, lo que pone de manifiesto la necesidad de adoptar más medidas para reducir la deforestación y aplicar prácticas sostenibles de gestión forestal y de la tierra.</p>
<p>Aunque todavía es difícil medir los efectos a corto y largo plazo de la pandemia de la COVID-19 en los bosques, es probable que la pandemia haya afectado a los bosques y a la silvicultura debido a los cambios en el flujo de la población urbana y rural y a la demanda adicional de determinados productos forestales.</p>
<p>Los bosques son las mayores reservas de carbono y biodiversidad del planeta. Son fuentes esenciales de alimentos, bienes y servicios y resultan fundamentales para los medios de vida de la población más pobre y las comunidades rurales. Se deberían promover enérgicamente los esfuerzos a escala mundial y regional para mantener los ecosistemas forestales, así como sus funciones social, económica y medioambiental, poniendo especial hincapié en los trópicos y en los países en desarrollo.</p>

	    </Container>
            <div className="chart-container">
                <div className="chart-title"><h2>Figura 69. Progresos hacia la gestión forestal sostenible</h2></div>
                <table className="table desktop-table colored-table">
                    <thead className="subcategory_thead enter">
                    <tr>
                        <th className="border-0"> </th>
                        <th className="pb-0 w-custom">
                            <div><span><small>Progresos entre las décadas de 2000-2010 y 2010-2020</small></span></div></th>
                        <th className="" colSpan="3">
                            <div><span><small>Progresos entre 2010-2020</small></span></div></th>
                        <th className="">
                            <div><span><small>Progresos entre 2010-2022</small></span></div></th>
                        <th className="">
                            <div><span><small>Progresos entre 2015-2022</small></span></div></th>
                        <th className="">
                            <div><span><small>Progresos entre 2021-22</small></span></div></th>
                    </tr>
                    </thead>
                    <thead className="subcategory_thead table-prevalence-title enter">
                    <tr>
                        <th>Región de los ODS</th>
                        <th className="rotate">
                            <div><span>Tasa de variación anual<br/> de la superficie forestal*</span></div></th>
                        <th className="rotate pb-0">
                            <div><span>Existencias de biomasa por<br/>encima del suelo en los<br/>bosques<br/>(toneladas/hectáreas)</span></div></th>
                        <th className="rotate pb-0">
                            <div><span>Porcentaje de la superficie<br/>forestal dentro de zonas<br/>protegidas legalmente<br/>establecidas</span></div></th>
                        <th className="rotate pb-0">
                            <div><span>Porcentaje de la superficie<br/>forestal sometida a un plan<br/>de gestión forestal a<br/>largo plazo</span></div></th>
                        <th className="rotate pb-0">
                            <div><span>Superficie forestal certificada<br/> (2010-2022)</span></div></th>
                        <th className="rotate pb-0">
                            <div><span>Superficie forestal certificada<br/> (2015-2022)</span></div></th>
                        <th className="rotate pb-0">
                            <div><span>Superficie forestal certificada<br/> (2021-22)</span></div></th>
                    </tr>
                    </thead>
                    <thead className="othcategory_thead enter">
                    <tr>
                        <th scope="row" className="teal">Mundo</th>
                        <td>
                            <span className="circle-y"></span>
                        </td>
                        <td>
                            <span className="circle-g"></span>

                        </td>
                        <td>
                            <span className="circle-r"></span>

                        </td>
                        <td>
                            <span className="circle-g"></span>

                        </td>
                        <td>
                            <span className="circle-g"></span>

                        </td>
                        <td>
                            <span className="circle-g"></span>

                        </td>
                        <td>
                            <span className="circle-r"></span>

                        </td>
                    </tr>
                    </thead>
                    <tbody className="enter">
                    <tr>
                        <th scope="row" className="font-weight-normal grey">Asia central y meridional</th>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-y"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-r"></span></td>
                        <td><span className="circle-g"></span></td>
                    </tr>
                    <tr>
                        <th scope="row" className="font-weight-normal"><ul className="mb-0"><li className="list-unstyled font-weight-normal"><em>Asia central</em></li></ul></th>
                        <td ><span className="circle-g"></span></td>
                        <td ><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td> </td>
                        <td> </td>
                        <td> </td>
                    </tr>
                    <tr>
                        <th scope="row" className="font-weight-normal"><ul className="mb-0"><li className="list-unstyled font-weight-normal"><em>Asia meridional</em></li></ul></th>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-y"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-y"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-r"></span></td>
                        <td><span className="circle-g"></span></td>
                    </tr>
                    <tr>
                        <th scope="row" className="font-weight-normal grey">Asia oriental y sudoriental</th>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-y"></span></td>
                    </tr>
                    <tr>
                        <th scope="row" className="font-weight-normal"><ul className="mb-0"><li className="list-unstyled font-weight-normal"><em>Asia oriental</em></li></ul></th>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-r"></span></td>
                        <td><span className="circle-r"></span></td>
                    </tr>
                    <tr>
                        <th scope="row" className="font-weight-normal"><ul className="mb-0"><li className="list-unstyled font-weight-normal"><em>Asia sudoriental</em></li></ul></th>
                        <td><span className="circle-r"></span></td>
                        <td><span className="circle-y"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-y"></span></td>
                    </tr>
                    <tr>
                        <th scope="row" className="font-weight-normal grey">Asia occidental y África septentrional</th>
                        <td><span className="circle-r"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-r"></span></td>
                    </tr>
                    <tr>
                        <th scope="row" className="font-weight-normal"><ul className="mb-0"><li className="list-unstyled font-weight-normal"><em>África septentrional</em></li></ul></th>
                        <td><span className="circle-r"></span></td>
                        <td><span className="circle-y"></span></td>
                        <td><span className="circle-y"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-r"></span></td>
                        <td scope="row" className="grey"> </td>
                        <td scope="row" className="grey"> </td>
                    </tr>
                    <tr>
                        <th scope="row" className="font-weight-normal"><ul className="mb-0"><li className="list-unstyled font-weight-normal"><em>Asia occidental</em></li></ul></th>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td scope="row" className="grey"> </td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-r"></span></td>
                    </tr>
                    <tr>
                        <th scope="row" className="font-weight-normal grey">África subsahariana</th>
                        <td><span className="circle-r"></span></td>
                        <td><span className="circle-y"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                    </tr>
                    <tr>
                        <th scope="row" className="font-weight-normal grey">América del Norte y Europa</th>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-r"></span></td>
                    </tr>
                    <tr>
                        <th scope="row" className="font-weight-normal"><ul className="mb-0"><li className="list-unstyled font-weight-normal"><em>Europa</em></li></ul></th>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-y"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-r"></span></td>
                    </tr>
                    <tr>
                        <th scope="row" className="font-weight-normal"><ul className="mb-0"><li className="list-unstyled font-weight-normal"><em>América septentrional</em></li></ul></th>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-r"></span></td>
                        <td><span className="circle-r"></span></td>
                    </tr>
                    <tr>
                        <th scope="row" className="font-weight-normal grey">América Latina y el Caribe</th>
                        <td><span className="circle-y"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                    </tr>
                    <tr>
                        <th scope="row" className="font-weight-normal grey">Oceanía</th>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-r"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-y"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                    </tr>
                    <tr>
                        <th><ul className="mb-0"><li className="list-unstyled font-weight-normal"><em>Oceanía (excluidas Australia y Nueva Zelandia)</em></li></ul></th>
                        <td><span className="circle-r"></span></td>
                        <td><span className="circle-y"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-y"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-r"></span></td>
                        <td><span className="circle-y"></span></td>
                    </tr>
                    <tr>
                        <th><ul className="mb-0"><li className="list-unstyled font-weight-normal"><em>Australia y Nueva Zelandia</em></li></ul></th>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-r"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-y"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                    </tr>
                    <tr>
                        <th scope="row" className="teal font-white">Países en desarrollo sin litoral (PDL)</th>
                        <td><span className="circle-r"></span></td>
                        <td><span className="circle-y"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-r"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                    </tr>
                    <tr>
                        <th scope="row" className="teal font-white">Países menos adelantados (PMA)</th>
                        <td><span className="circle-r"></span></td>
                        <td><span className="circle-y"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                    </tr>
                    <tr>
                        <th scope="row" className="teal font-white">Pequeños Estados insulares en desarrollo (PEID)</th>
                        <td><span className="circle-r"></span></td>
                        <td><span className="circle-y"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-r"></span></td>
                    </tr>
                    </tbody>
                </table>
                <table className="table mobile-table">
                    <tbody>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Mundo</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Tasa de variación anual de la superficie forestal*</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Existencias de biomasa por encima del suelo en los bosques (toneladas/hectáreas)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal dentro de zonas protegidas legalmente establecidas</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2010-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2015-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2021-22)</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Asia central y meridional</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Tasa de variación anual de la superficie forestal*</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Existencias de biomasa por encima del suelo en los bosques (toneladas/hectáreas)</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal dentro de zonas protegidas legalmente establecidas</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2010-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2015-2022)</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2021-22)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Asia central</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Tasa de variación anual de la superficie forestal*</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Existencias de biomasa por encima del suelo en los bosques (toneladas/hectáreas)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal dentro de zonas protegidas legalmente establecidas</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2010-2022)</td>
                        <td className="data"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2015-2022)</td>
                        <td className="data"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2021-22)</td>
                        <td className="data"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Asia meridional</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Tasa de variación anual de la superficie forestal*</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Existencias de biomasa por encima del suelo en los bosques (toneladas/hectáreas)</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal dentro de zonas protegidas legalmente establecidas</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2010-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2015-2022)</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2021-22)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Asia oriental y sudoriental</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Tasa de variación anual de la superficie forestal*</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Existencias de biomasa por encima del suelo en los bosques (toneladas/hectáreas)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal dentro de zonas protegidas legalmente establecidas</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2010-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2015-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2021-22)</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Asia oriental</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Tasa de variación anual de la superficie forestal*</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Existencias de biomasa por encima del suelo en los bosques (toneladas/hectáreas)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal dentro de zonas protegidas legalmente establecidas</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2010-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2015-2022)</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2021-22)</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Asia sudoriental</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Tasa de variación anual de la superficie forestal*</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Existencias de biomasa por encima del suelo en los bosques (toneladas/hectáreas)</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal dentro de zonas protegidas legalmente establecidas</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2010-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2015-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2021-22)</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Asia occidental y África septentrional</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Tasa de variación anual de la superficie forestal*</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Existencias de biomasa por encima del suelo en los bosques (toneladas/hectáreas)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal dentro de zonas protegidas legalmente establecidas</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2010-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2015-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2021-22)</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">África septentrional</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Tasa de variación anual de la superficie forestal*</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Existencias de biomasa por encima del suelo en los bosques (toneladas/hectáreas)</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal dentro de zonas protegidas legalmente establecidas</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2010-2022)</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2015-2022)</td>
                        <td className="data"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2021-22)</td>
                        <td className="data"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Asia occidental</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Tasa de variación anual de la superficie forestal*</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Existencias de biomasa por encima del suelo en los bosques (toneladas/hectáreas)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal dentro de zonas protegidas legalmente establecidas</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2010-2022)</td>
                        <td className="data"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2015-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2021-22)</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">África subsahariana</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Tasa de variación anual de la superficie forestal*</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Existencias de biomasa por encima del suelo en los bosques (toneladas/hectáreas)</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal dentro de zonas protegidas legalmente establecidas</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2010-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2015-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2021-22)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">América del Norte y Europa</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Tasa de variación anual de la superficie forestal*</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Existencias de biomasa por encima del suelo en los bosques (toneladas/hectáreas)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal dentro de zonas protegidas legalmente establecidas</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2010-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2015-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2021-22)</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Europa</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Tasa de variación anual de la superficie forestal*</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Existencias de biomasa por encima del suelo en los bosques (toneladas/hectáreas)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal dentro de zonas protegidas legalmente establecidas</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2010-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2015-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2021-22)</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">América septentrional</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Tasa de variación anual de la superficie forestal*</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Existencias de biomasa por encima del suelo en los bosques (toneladas/hectáreas)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal dentro de zonas protegidas legalmente establecidas</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2010-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2015-2022)</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2021-22)</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">América Latina y el Caribe</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Tasa de variación anual de la superficie forestal*</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Existencias de biomasa por encima del suelo en los bosques (toneladas/hectáreas)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal dentro de zonas protegidas legalmente establecidas</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2010-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2015-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2021-22)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Oceanía</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Tasa de variación anual de la superficie forestal*</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Existencias de biomasa por encima del suelo en los bosques (toneladas/hectáreas)</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal dentro de zonas protegidas legalmente establecidas</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2010-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2015-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2021-22)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Oceanía (excluidas Australia y Nueva Zelandia)</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Tasa de variación anual de la superficie forestal*</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Existencias de biomasa por encima del suelo en los bosques (toneladas/hectáreas)</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal dentro de zonas protegidas legalmente establecidas</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2010-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2015-2022)</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2021-22)</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Australia y Nueva Zelandia</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Tasa de variación anual de la superficie forestal*</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Existencias de biomasa por encima del suelo en los bosques (toneladas/hectáreas)</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal dentro de zonas protegidas legalmente establecidas</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2010-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2015-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2021-22)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Países en desarrollo sin litoral (PDL)</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Tasa de variación anual de la superficie forestal*</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Existencias de biomasa por encima del suelo en los bosques (toneladas/hectáreas)</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal dentro de zonas protegidas legalmente establecidas</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2010-2022)</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2015-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2021-22)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Países menos adelantados (PMA)</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Tasa de variación anual de la superficie forestal*</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Existencias de biomasa por encima del suelo en los bosques (toneladas/hectáreas)</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal dentro de zonas protegidas legalmente establecidas</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2010-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2015-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2021-22)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Pequeños Estados insulares en desarrollo (PEID)</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Tasa de variación anual de la superficie forestal*</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Existencias de biomasa por encima del suelo en los bosques (toneladas/hectáreas)</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal dentro de zonas protegidas legalmente establecidas</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2010-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2015-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestal certificada (2021-22)</td>
                        <td className="data red"></td>
                    </tr>
                    </tbody>
                </table>
                <ul className="list-unstyled list-inline text-center legend legend-table mt-4 half-width-entries">
                    <li className="list-inline-item"><span className="point position-static"></span>Variación positiva</li>
                    <li className="list-inline-item"><span className="point position-static"></span>Variación escasa/Sin variación</li>
                    <li className="list-inline-item"><span className="point position-static"></span>Variación negativa</li>
                    <li className="list-inline-item"><span className="point position-static"></span>Superficie no certificada</li>
                </ul>
                <p className="note text-center">Nota: * La tasa anual de variación de la superficie forestal se calcula empleando una fórmula de interés compuesto.<br/><b>Fuente:</b> FAO. 2023. Datos. En: <i>Portal de datos de indicadores de los ODS</i>. Roma. [Consultado el 8 de junio de 2023]. <a href="https://www.fao.org/sustainable-development-goals-data-portal/data/es">https://www.fao.org/sustainable-development-goals-data-portal/data/es</a></p>
            </div>
	                <ContainerChart
                title="Figura 70. Superficie forestal certificada (1 000 hectáreas)"
                legend={[
                    {title: '2010', color: '#e2f0d9'},
                    {title: '2015', color: '#a9d18e'},
                    {title: '2022', color: '#70ad47'},
                ]}
			 note={<span><b>Fuente:</b> FAO. 2023. Datos. En:<i> Portal de datos de indicadores de los ODS. </i>Roma. [Consultado el 8 de junio de 2023]. <a href="https://www.fao.org/sustainable-development-goals-data-portal/data/es">https://www.fao.org/sustainable-development-goals-data-portal/data/es</a><br/><a href="https://doi.org/10.4060/CC7088EN-fig70" download>https://doi.org/10.4060/CC7088EN-fig70</a></span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure70}
                />
            </ContainerChart>

<Container>
		                <div id="section15.3.1">
                    <HeaderSdg 
                        title="INDICADOR 15.3.1 DE LOS ODS"
                        subtitle={["Proporción de tierras degradadas en comparación con la superficie total", <sup>8</sup>]}
                        badges={[
                            {color: '#ffff05', text: 'Evaluación de la situación mundial: distancia moderada de la meta.'},
                            { color: '#ff6261', text: 'Evaluación de la tendencia mundial: deterioro.'},
                        ]}
                        target={{
                            sdg: "15",
                            title: 'Meta 15.3',
                            text: 'De aquí a 2030, luchar contra la desertificación, rehabilitar las tierras y los suelos degradados, incluidas las tierras afectadas por la desertificación, la sequía y las inundaciones, y procurar lograr un mundo con efecto neutro en la degradación del suelo.'
                        }}
                    />
                </div>

<p><b>La tendencia negativa en la degradación de la tierra continúa, afectando a la vida de 1 300 millones de personas.</b></p>
<p>Entre 2015 y 2019, el mundo ha estado perdiendo al menos 100 millones de hectáreas de tierra productiva y en buen estado cada año. Esto equivale a una superficie dos veces mayor que la de Groenlandia perdida en cuatro años. El empeoramiento de estas tendencias afecta a la vida de 1 300 millones de personas, que se estima están directamente expuestas a la degradación de la tierra. Entre 2000 y 2019, en Asia oriental, América Latina y el Caribe, y Asia central, al menos el 20 % de la superficie terrestre total estaba degradada, mientras que en la mayoría de las demás regiones superaba el 10 %. Las tendencias desde 2015 muestran que la tierra en el África subsahariana, Asia occidental, América Latina y el Caribe y Asia meridional se está degradando considerablemente más rápido que la media mundial, con aumentos de entre el 6 y el 8 %. Se trata de estimaciones prudentes basadas en solo tres subindicadores: cambios en la cobertura del suelo, productividad de la tierra y carbono orgánico en el suelo.</p>
<p>Los países han identificado como generadores directos de la degradación del suelo las actividades humanas, entre ellas la expansión urbana, la deforestación y la conversión de pastizales. Los pastizales sufrieron algunas de las mayores pérdidas de productividad de la tierra, seguidos de las tierras de cultivo y las zonas arboladas. Los países que presentaron información indicaron que generadores indirectos, como las tendencias demográficas y económicas, los retos institucionales y en materia de gobernanza, y las deficiencias en la inversión y el acceso a la tecnología, deben abordarse para permitir una respuesta eficaz a la degradación de la tierra.</p>
<p>En el ecuador de la aplicación de los ODS, si continúan estas tendencias alarmantes de degradación de la tierra, sería necesario restaurar 1 500 millones de hectáreas para 2030 con el fin de garantizar un mundo neutro en la degradación de la tierra. Sin embargo, si se evitara la degradación de tierras nuevas y se acelerara la aplicación de los compromisos existentes para restaurar 1 000 millones de hectáreas, la meta relativa a la neutralidad no solo se alcanzaría, sino que se superaría para 2030. Esto requeriría mayores inversiones en conservación, gestión sostenible y restauración de la tierra, mediante una planificación integrada del uso de la tierra y sólidas salvaguardias ambientales y sociales.</p>
<p>La restauración de la tierra incluye una amplia variedad de prácticas de gestión sostenible de la tierra y el agua que pueden aplicarse a: i) conservar áreas naturales o hacer que ʺrecuperen su vida silvestreʺ; ii) aumentar la producción de alimentos respetuosos con la naturaleza en los paisajes rurales, y iii) ecologizar las zonas urbanas, las infraestructuras y las cadenas de suministro. La agenda de restauración de la tierra promueve una estrategia de múltiples beneficios que revierte la degradación de la tierra y la pérdida de biodiversidad del pasado, al tiempo que aumenta la seguridad alimentaria y del agua, mejora los medios de vida y mitiga y se adapta al cambio climático.</p>
<p>La restauración de la tierra es una responsabilidad compartida: todo el mundo tiene un papel que desempeñar porque a todos nos interesa la salud de la tierra, ahora y en el futuro. Los gobiernos, las empresas y las comunidades pueden restaurar de manera conjunta la tierra buscando la convergencia y la complementariedad. Las prioridades ambientales y en materia de desarrollo pueden gestionarse de forma responsable para crear un mosaico más saludable de usos de la tierra sin poner en peligro las necesidades y aspiraciones de las generaciones actuales y futuras.</p>
</Container>
	                <ContainerChart
                title="Figura 71. Proporción de tierras degradadas, porcentaje (2015 y 2019)"
                legend={[
                    {title: '2015', color: '#a9d18e'},
                    {title: '2019', color: '#e2f0d9'},
                ]}
			 note={<span>Nota: (1) Excluidas las Maldivas; (2) Excluidos los Estados Unidos de América; (3) Excluidos Belarús, Dinamarca, la Federación de Rusia, Luxemburgo, Malta, Mónaco, Noruega y Suiza; (4) Excluidos Angola y las Comoras; (5) Excluidos Brunei Darussalam y Singapur; (6) Excluidos Barbados y Granada; (7) Excluidos Japón y la República de Corea.<br/><b>Fuente:</b> FAO. 2023. Datos. En: <i>Portal de datos de indicadores de los ODS</i>. Roma. [Consultado el 8 de junio de 2023]. <a href="https://www.fao.org/sustainable-development-goals-data-portal/data/es">https://www.fao.org/sustainable-development-goals-data-portal/data/es</a><br/><a href="https://doi.org/10.4060/CC7088EN-fig71" download>https://doi.org/10.4060/CC7088EN-fig71</a></span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure71}
                />
            </ContainerChart>

            {/* Interactive Map  */}
            <ContainerChart
                title="Figura 72. Estado actual de la superficie de tierra degradada (2019)"
                legend={[
                    {title: 'Meta ya alcanzada', color: '#00a700'},
                    {title: 'Cerca de la meta', color: '#2acb2a'},
		    {title: 'Distancia moderada de la meta', color: '#ffff05'},
		    {title: 'Lejos de la meta', color: '#ffa500'},
		    {title: 'Muy lejos de la meta', color: '#ff0000'},
		    {title: 'Datos insuficientes', color: '#808080'},
                ]}
                source={<span><b>Fuente:</b> FAO. 2023. Datos. En: <i>Portal de datos de indicadores de los ODS</i>. Roma. [Consultado el 8 de junio de 2023]. <a href="https://www.fao.org/sustainable-development-goals-data-portal/data/es">https://www.fao.org/sustainable-development-goals-data-portal/data/es</a>  (modificado para ajustarse a lo dispuesto en la Sección de Información Geoespacial de las Naciones Unidas, 2023).<br/></span>}
                note={<span>Nota:  La línea de puntos representa aproximadamente la línea de control de Jammu y Kashmir acordada por la India y el Pakistán. El estatuto final de Jammu y Kashmir todavía no ha sido acordado por las partes. La frontera definitiva entre la República del Sudán y la República de Sudán del Sur todavía no se ha determinado.<br/>Todavía no se ha determinado el estatuto definitive de la zona de Abyei. Existe una disputa entre los Gobiernos de la Argentina y el Reino Unido de Gran Bretaña e Irlanda del Norte acerca de la soberanía sobre las Islas Malvinas (Falkland Islands).</span>}>
                <iframe loading='lazy' className='chart-container-image' style={{border: 'none'}} title='map72' src="fig72.html" width='100%'  height='500px'/>

            </ContainerChart>

            {/* Interactive Map  */}
            <ContainerChart
                title="Figura 73. Tendencia de la degradación mundial de la tierra (2015-19)"
                legend={[
                    {title: 'Meta ya alcanzada', color: '#00a700'},
                    {title: 'En buen camino', color: '#2acb2a'},
		    {title: 'En camino, pero demasiado lento', color: '#ffff05'},
		    {title: 'Sin mejora', color: '#ffa500'},
		    {title: 'Deterioro', color: '#ff0000'},
		    {title: 'Datos insuficientes', color: '#808080'},
                ]}
                source={<span><b>Fuente:</b> FAO. 2023. Datos. En: <i>Portal de datos de indicadores de los ODS</i>. Roma. [Consultado el 8 de junio de 2023]. <a href="https://www.fao.org/sustainable-development-goals-data-portal/data/es">https://www.fao.org/sustainable-development-goals-data-portal/data/es</a>  (modificado para ajustarse a lo dispuesto en la Sección de Información Geoespacial de las Naciones Unidas, 2023).<br/></span>}
                note={<span>Nota: La línea de puntos representa aproximadamente la línea de control de Jammu y Kashmir acordada por la India y el Pakistán. El estatuto final de Jammu y Kashmir todavía no ha sido acordado por las partes. La frontera definitiva entre la República del Sudán y la República de Sudán del Sur todavía no se ha determinado.<br/>Todavía no se ha determinado el estatuto definitive de la zona de Abyei. Existe una disputa entre los Gobiernos de la Argentina y el Reino Unido de Gran Bretaña e Irlanda del Norte acerca de la soberanía sobre las Islas Malvinas (Falkland Islands).</span>}>
                <iframe loading='lazy' className='chart-container-image' style={{border: 'none'}} title='map73' src="fig73.html" width='100%'  height='500px'/>

            </ContainerChart>

<Container>
<div id="section15.4.2">
                    <HeaderSdg 
                        title="INDICADOR 15.4.2 DE LOS ODS"
                        subtitle="a) Índice de cobertura verde de las montañas y b) Proporción de la superficie montañosa degradada"
                        badges={[
                            {color: '#FFC000', text: 'a) Evaluación de la situación mundial: por debajo de la mediana de los valores nacionales.'},
                            { color: '#92D050', text: 'Evaluación de la tendencia mundial: mejora leve o nula.'},
		       {color: '#92D050', text: 'b) Evaluación de la situación mundial: cerca de la meta.'},
                            { color: '#ff6261', text: 'Evaluación de la tendencia mundial: deterioro.'},
                        ]}
                        target={{
                            sdg: "15",
                            title: 'Meta 15.4',
                            text: 'De aquí a 2030, asegurar la conservación de los ecosistemas montañosos, incluida su diversidad biológica, a fin de mejorar su capacidad de proporcionar beneficios esenciales para el desarrollo sostenible.'
                        }}
                    />
                </div>

<p><b>La proporción de superficie montañosa degradada se sitúa en el 1,6 % de la superficie montañosa mundial.</b></p>
<p>La cobertura verde de las montañas se ha mantenido más o menos estable, en torno al 78 % durante el periodo 2000-2018, con un descenso insignificante (0,05 %) desde 2015. La desagregación de las zonas montañosas por cobertura del suelo y región geográfica brinda información adicional, permitiendo visualizar cómo las características biofísicas y los usos históricos y recientes de la tierra configuran sus paisajes (Figura 74).</p>
</Container>
	                <ContainerChart
                title="Figura 74. Índice de cobertura verde de las montañas por tipo de cobertura del suelo (2018)"
                legend={[
                    {title: 'Superficies artificiales', color: '#c00000', customCSSClass: 'half-width'},
                    {title: 'Tierras cultivables', color: '#fed966', customCSSClass: 'half-width'},
                    {title: 'Praderas', color: '#c4dda0', customCSSClass: 'half-width'},
                    {title: 'Zonas cubiertas de árboles', color: '#548135', customCSSClass: 'half-width'},
                    {title: 'Zonas cubiertas de arbustos', color: '#82b99c', customCSSClass: 'half-width'},
                    {title: 'Humedales', color: '#65b3d6', customCSSClass: 'half-width'},
                    {title: 'Zonas con escasa vegetación', color: '#dcca8f', customCSSClass: 'half-width'},
                    {title: 'Terreno raso terrestre', color: '#9a8f72', customCSSClass: 'half-width'},
                    {title: 'Nieve permanente y glaciares', color: '#d6dce5', customCSSClass: 'half-width'},
                    {title: 'Masas de aguas continentales', color: '#5475a8', customCSSClass: 'half-width'},		
                ]}
			 note={<span>Nota: Eje derecho: distribución de los tipos de cobertura del suelo en las diferentes regiones de los ODS en 2018. La altura de cada barra indica la superficie montañosa total de cada región del ODS. Eje izquierdo: valores del índice de cobertura verde de las montañas en 2018, representados como puntos negros.<br/><b>Fuente:</b> FAO. 2023. Datos. En: <i>Portal de datos de indicadores de los ODS</i>. Roma. [Consultado el 8 de junio de 2023]. <a href="https://www.fao.org/sustainable-development-goals-data-portal/data/es">https://www.fao.org/sustainable-development-goals-data-portal/data/es</a></span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure74}
                />
            </ContainerChart>
	    <Container>
<p>Las áreas cubiertas de árboles son el tipo de cobertura del suelo de las montañas dominante en todo el mundo, especialmente en Oceanía (90 % de la superficie montañosa total), Europa y América septentrional (52 %), América Latina y el Caribe (42 %), Asia oriental y meridional (38 %) y el África subsahariana (35 %). Solo hay dos excepciones: África septentrional y Asia occidental, donde predominan los terrenos rasos (40 %) y las tierras de cultivo (25 %), y Asia central y meridional, donde los terrenos rasos (26 %), los pastizales (24 %) y las tierras de cultivo (20 %) son los tipos de cobertura del suelo más extendidos.</p>
<p>Las regiones tropicales y subtropicales caracterizadas por cadenas montañosas de altitud baja o media, como Oceanía, tienden a mostrar los valores más altos de cobertura verde (99 %). Por el contrario, las regiones caracterizadas por cadenas montañosas de gran altitud situadas en zonas templadas y boreales, donde las condiciones ambientales son menos favorables para el crecimiento de la vegetación, como Asia central, América septentrional y Europa, tienden a mostrar valores más bajos de cobertura verde (64 % y 76 %, respectivamente). Las regiones áridas como África septentrional y Asia occidental también suelen mostrar valores bajos de superficie de cobertura verde (46 %).</p>
<p>Los cambios perjudiciales en la cobertura y el uso del suelo contribuyen en gran medida a la pérdida de biodiversidad terrestre, incluso en los ecosistemas de montaña. La proporción de superficie montañosa degradada mide esto calculando la cantidad de superficie montañosa en la que los cambios en la cobertura del suelo pueden indicar una disminución o pérdida de biodiversidad, funciones de los ecosistemas de montaña o los servicios considerados deseables en un contexto local o nacional. A estos efectos, las transiciones de la cobertura del suelo que indican una disminución o pérdida de biodiversidad y de servicios de los ecosistemas de montaña se consideran degradación de la superficie montañosa.</p>
<p className="text-center mb-0"><span><b>Cuadro 4: Cinturones bioclimáticos de montaña y reclasificación para el desglose de datos del indicador 15.4.2 de los ODS</b></span></p>
                    <table className="annex-table text-center">
                        <thead>
<tr className="text-left">
<th>Cinturones bioclimáticos</th>
<th>Temperatura media en la temporada de crecimiento</th>
<th>Duración de la temporada de crecimiento</th>
<th>Cinturones bioclimáticos adoptados para el indicador 15.4.2 de los ODS</th>
</tr>
</thead>
<tbody>
<tr className="text-left">
<td className="text-left"><b>Basal</b></td>
<td>&lt; 3,5 °C</td>
<td>&lt; 10 días</td>
<td>Basal</td>
</tr>
<tr className="text-left">
<td className="text-left"><b>Alto alpino</b></td>
<td>&lt; 3,5 °C</td>
<td>&gt; 10 días y &lt; 54 días</td>
<td rowspan="2">Alpino</td>
</tr>
<tr className="text-left">
<td className="text-left"><b>Bajo alpino</b></td>
<td>&lt; 6,4 °C</td>
<td>&lt; 54 días</td>
</tr>
<tr>
<td colspan="4" className="text-center"><b>EL LÍMITE ARBÓREO</b></td>
</tr>
<tr className="text-left">
<td className="text-left"><b>Alto montano</b></td>
<td>&gt; 6,4 °C y &#x003C; 10 °C</td>
<td>---</td>
<td rowspan="2">Montano</td>
</tr>
<tr className="text-left">
<td className="text-left"><b>Bajo montano</b></td>
<td>&gt; 10 °C y &#x003C; 15 °C</td>
<td>---</td>
</tr>
<tr className="text-left">
<td className="text-left"><b>Zona montañosa restante con heladas</b></td>
<td>&gt; 15 °C</td>
<td rowspan="2">---</td>
<td rowspan="2">Zonas montañosas restantes</td>
</tr>
<tr className="text-left">
<td><b>Zona montañosa restante sin heladas</b></td>
<td>&gt; 15 °C</td>
</tr>
</tbody>
</table>
<p className="note text-center">Nota: Las montañas pueden subdividirse verticalmente en siete cinturones bioclimáticos basados en las temperaturas medias, lo que ayuda a explicar el cambio latitudinal en la elevación de zonas térmicamente similares en las montañas del mundo. A efectos del indicador 15.4.2, estos siete cinturones bioclimáticos se agrupan en cuatro (basal, alpino, montano y zonas montañosas restantes)<br/><b>Fuente:</b> Körner, C., Paulsen, J. y Spehn, E. 2011. A definition of mountains and their bioclimatic belts for global comparisons of biodiversity data. <i>Alpine Botany</i>, 121: 73-78.</p>
<p>Los datos mundiales disponibles indican que la zona en la que se produjeron cambios perjudiciales en la cobertura del suelo durante el periodo 2000-2018 representa aproximadamente el 1,6 % de la superficie montañosa total del mundo. Los datos desagregados muestran que los cinturones montañosos más afectados por los cambios perjudiciales en la cobertura del suelo fueron los cinturones alpino (1,8 %) y montano (1,7 %), mientras que las zonas basales fueron las menos afectadas (0,08 %) (Figura 75)<sup onClick={() => handleClickOpen('Estos valores deben interpretarse con cautela, dado que los cambios en la superficie de nieve y hielo permanentes aún no están recogidos en el conjunto de datos mundial sobre la cobertura del suelo utilizado para el análisis (Agencia Espacial Europea, 2017).')}>9</sup>. El desglose tanto por regiones de los ODS como por cinturones bioclimáticos muestra que las zonas con mayor proporción de superficie montañosa degradada son las zonas alpinas de Europa y América septentrional (2,3%), seguidas de las zonas montañosas de Asia central y meridional (2,2 %) y los cinturones montañosos más bajos de Asia oriental y meridional (2,1 %).</p>
	    </Container>
	                <ContainerChart
                title="Figura 75. Proporción de superficie montañosa degradada en las distintas regiones de los ODS, desglosada por cinturón bioclimático, 2000-2018"
                legend={[
                    {title: 'Basal', color: '#a5a5a5', customCSSClass: 'half-width'},
                    {title: 'Alpino', color: '#e6ddcc', customCSSClass: 'half-width'},
                    {title: 'Montano', color: '#a9b6a2', customCSSClass: 'half-width'},
                    {title: 'Zona montañosa restante', color: '#6c8b8d', customCSSClass: 'half-width'},
                ]}
			 note={<span><b>Fuente:</b> FAO. 2023. Datos. En: <i>Portal de datos de indicadores de los ODS</i>. Roma. [Consultado el 8 de junio de 2023]. <a href="https://www.fao.org/sustainable-development-goals-data-portal/data/es">https://www.fao.org/sustainable-development-goals-data-portal/data/es</a></span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure75}
                />
            </ContainerChart>
<Container>
<p>Por último, un análisis de los cambios en los tipos de cobertura del suelo en las zonas montañosas del mundo muestra que el área de la superficie artificial se duplicó con creces (con un aumento del 106 %) durante el periodo 2000-2018, especialmente por debajo del límite arbóreo (zonas montañosas y zonas montañosas restantes). Las zonas de humedales situadas por debajo del límite arbóreo también experimentaron un importante descenso durante el mismo periodo (Figura 76).</p>
</Container>
	                <ContainerChart
                title="Figura 76. Cambios en la superficie de los diferentes tipos de cobertura del suelo en la superficie montañosa mundial durante el período comprendido entre 2000 y 2018"
                legend={[
                    {title: 'Basal', color: '#a5a5a5', customCSSClass: 'half-width'},
                    {title: 'Alpino', color: '#e6ddcc', customCSSClass: 'half-width'},
                    {title: 'Montano', color: '#a9b6a2', customCSSClass: 'half-width'},
                    {title: 'Zona montañosa restante', color: '#6c8b8d', customCSSClass: 'half-width'},
                ]}
			 note={<span><b>Fuente:</b> FAO. 2023. Datos. En: <i>Portal de datos de indicadores de los ODS</i>. Roma. [Consultado el 8 de junio de 2023]. <a href="https://www.fao.org/sustainable-development-goals-data-portal/data/es">https://www.fao.org/sustainable-development-goals-data-portal/data/es</a></span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure76}
                />
            </ContainerChart>
	                {/* Interactive Map  */}
            <ContainerChart
                title="Figura 77.  Estado actual del índice de cobertura verde de las montañas, por quintiles (2018)"
                legend={[
                    {title: 'Quinto quintil', color: '#00a700'},
                    {title: 'Cuarto quintil', color: '#2acb2a'},
		    {title: 'Tercer quintil', color: '#ffff05'},
		    {title: 'Segundo quintil', color: '#ffa500'},
		    {title: 'Primer quintil', color: '#ff0000'},
		    {title: 'Datos insuficientes', color: '#808080'},
                ]}
                source={<span><b>Fuente:</b> FAO. 2023. Datos. En: <i>Portal de datos de indicadores de los ODS</i>. Roma. [Consultado el 8 de junio de 2023]. <a href="https://www.fao.org/sustainable-development-goals-data-portal/data/es">https://www.fao.org/sustainable-development-goals-data-portal/data/es</a>  (modificado para ajustarse a lo dispuesto en la Sección de Información Geoespacial de las Naciones Unidas, 2023).<br/></span>}
                note={<span>Nota: La línea de puntos representa aproximadamente la línea de control de Jammu y Kashmir acordada por la India y el Pakistán. El estatuto final de Jammu y Kashmir todavía no ha sido acordado por las partes. La frontera definitiva entre la República del Sudán y la República de Sudán del Sur todavía no se ha determinado.<br/>Todavía no se ha determinado el estatuto definitive de la zona de Abyei. Existe una disputa entre los Gobiernos de la Argentina y el Reino Unido de Gran Bretaña e Irlanda del Norte acerca de la soberanía sobre las Islas Malvinas (Falkland Islands).</span>}>
                <iframe loading='lazy' className='chart-container-image' style={{border: 'none'}} title='map77' src="fig77.html" width='100%'  height='500px'/>

            </ContainerChart>

            {/* Interactive Map  */}
            <ContainerChart
                title="Figura 78. Tendencia en la mejora del índice de cobertura verde de las montañas por región (2015-18)"
                legend={[
                    {title: 'Mejora', color: '#00a700'},
                    {title: 'Mejora leve o ninguna', color: '#2acb2a'},
		    {title: 'Ligero deterioro', color: '#ffa500'},
		    {title: 'Deterioro', color: '#ff0000'},
		    {title: 'Datos insuficientes', color: '#808080'},
                ]}
                source={<span><b>Fuente:</b> FAO. 2023. Datos. En: <i>Portal de datos de indicadores de los ODS</i>. Roma. [Consultado el 8 de junio de 2023]. <a href="https://www.fao.org/sustainable-development-goals-data-portal/data/es">https://www.fao.org/sustainable-development-goals-data-portal/data/es</a>  (modificado para ajustarse a lo dispuesto en la Sección de Información Geoespacial de las Naciones Unidas, 2023).<br/></span>}
                note={<span>Nota: La línea de puntos representa aproximadamente la línea de control de Jammu y Kashmir acordada por la India y el Pakistán. El estatuto final de Jammu y Kashmir todavía no ha sido acordado por las partes. La frontera definitiva entre la República del Sudán y la República de Sudán del Sur todavía no se ha determinado.<br/>Todavía no se ha determinado el estatuto definitive de la zona de Abyei. Existe una disputa entre los Gobiernos de la Argentina y el Reino Unido de Gran Bretaña e Irlanda del Norte acerca de la soberanía sobre las Islas Malvinas (Falkland Islands).</span>}>
                <iframe loading='lazy' className='chart-container-image' style={{border: 'none'}} title='map78' src="fig78.html" width='100%'  height='500px'/>

            </ContainerChart>

            {/* Interactive Map  */}
            <ContainerChart
                title="Figura 79. Estado actual de la degradación de la superficie montañosa (2018)"
                legend={[
                    {title: 'Meta ya alcanzada', color: '#00a700'},
                    {title: 'Cerca de la meta', color: '#2acb2a'},
		    {title: 'Distancia moderada de la meta', color: '#ffff05'},
		    {title: 'Lejos de la meta', color: '#ffa500'},
		    {title: 'Muy lejos de la meta', color: '#ff0000'},
		    {title: 'Datos insuficientes', color: '#808080'},
                ]}
                source={<span><b>Fuente:</b> FAO. 2023. Datos. En: <i>Portal de datos de indicadores de los ODS</i>. Roma. [Consultado el 8 de junio de 2023]. <a href="https://www.fao.org/sustainable-development-goals-data-portal/data/es">https://www.fao.org/sustainable-development-goals-data-portal/data/es</a>  (modificado para ajustarse a lo dispuesto en la Sección de Información Geoespacial de las Naciones Unidas, 2023).<br/></span>}
                note={<span>Nota: La línea de puntos representa aproximadamente la línea de control de Jammu y Kashmir acordada por la India y el Pakistán. El estatuto final de Jammu y Kashmir todavía no ha sido acordado por las partes. La frontera definitiva entre la República del Sudán y la República de Sudán del Sur todavía no se ha determinado.<br/>Todavía no se ha determinado el estatuto definitive de la zona de Abyei. Existe una disputa entre los Gobiernos de la Argentina y el Reino Unido de Gran Bretaña e Irlanda del Norte acerca de la soberanía sobre las Islas Malvinas (Falkland Islands).</span>}>
                <iframe loading='lazy' className='chart-container-image' style={{border: 'none'}} title='map79' src="fig79.html" width='100%'  height='500px'/>

            </ContainerChart>

            {/* Interactive Map  */}
            <ContainerChart
                title="Figura 80. Tendencia de la degradación de la superficie montañosa (2015-18)"
                legend={[
                    {title: 'Meta ya alcanzada', color: '#00a700'},
                    {title: 'En buen camino', color: '#2acb2a'},
		    {title: 'En camino, pero demasiado lento', color: '#ffff05'},
		    {title: 'Ninguna mejora desde el inicio', color: '#ffa500'},
		    {title: 'Deterioro', color: '#ff0000'},
		    {title: 'Datos insuficientes', color: '#808080'},
                ]}
                source={<span><b>Fuente:</b> FAO. 2023. Datos. En: <i>Portal de datos de indicadores de los ODS</i>. Roma. [Consultado el 8 de junio de 2023]. <a href="https://www.fao.org/sustainable-development-goals-data-portal/data/es">https://www.fao.org/sustainable-development-goals-data-portal/data/es</a>  (modificado para ajustarse a lo dispuesto en la Sección de Información Geoespacial de las Naciones Unidas, 2023).<br/></span>}
                note={<span>Nota: La línea de puntos representa aproximadamente la línea de control de Jammu y Kashmir acordada por la India y el Pakistán. El estatuto final de Jammu y Kashmir todavía no ha sido acordado por las partes. La frontera definitiva entre la República del Sudán y la República de Sudán del Sur todavía no se ha determinado.<br/>Todavía no se ha determinado el estatuto definitive de la zona de Abyei. Existe una disputa entre los Gobiernos de la Argentina y el Reino Unido de Gran Bretaña e Irlanda del Norte acerca de la soberanía sobre las Islas Malvinas (Falkland Islands).</span>}>
                <iframe loading='lazy' className='chart-container-image' style={{border: 'none'}} title='map80' src="fig80.html" width='100%'  height='500px'/>

            </ContainerChart>

 <Container>
                <div id="section15.6.1">
                    <HeaderSdg
                        title="INDICADOR 15.6.1 DE LOS ODS"
                        subtitle={["Número de países que han aprobado marcos legislativos, administrativos y normativos para garantizar una participación justa y equitativa en los beneficios.", <sup>10</sup>]}
                        // badges={[
                        //     {color: '#ffbf02', text: 'Status assessment: Not possible due to absence of numerical yardstick in target'},
                        //     {color: '#ff6261', text: 'Trend assessment: Slight or no improvement'},
                        // ]}
                        target={{
                            sdg: "15",
                            title: 'Meta 15.6',
                            text: 'Promover la participación justa y equitativa en los beneficios derivados de la utilización de los recursos genéticos y promover el acceso adecuado a esos recursos, según lo convenido internacionalmente.'
                        }}
                    />
                </div>

<div className="text-in-box mt-5">
   <HeaderSdg
                        title="INDICADOR 15.6.1 DE LOS ODS"
                        subtitle="Países que son partes contratantes en el Tratado Internacional sobre los Recursos Fitogenéticos para la Alimentación y la Agricultura"
                         badges={[
                             {color: '#cecece', text: 'Situación actual: imposible de realizar debido a la ausencia de un criterio numérico en la meta.'},
                             {color: '#00a700', text: 'Tendencia: mejora.'},
                         ]}
                                            />
	  <Subtitle text="Países que notificaron tener establecidos unos marcos o medidas de carácter legislativo, administrativo y normativo a través del Sistema en línea para la notificación del cumplimiento del Tratado Internacional sobre los Recursos Fitogenéticos para la Alimentación y la Agricultura" />	     
	     <div className="sdg-header" id="header2-1-2">
    <div className="text-center">
<div className="badge badge-pill" style={{background: '#cecece'}}>Situación actual: imposible de realizar debido a la ausencia de un criterio numérico en la meta.</div>
<div className="badge badge-pill" style={{background: '#00a700'}}>Tendencia: mejora.</div>
    </div>
</div>
<Subtitle text="Número total notificado de acuerdos normalizados de transferencia de material por los que se transfieren al país recursos fitogenéticos para la alimentación y la agricultura" />	     
	     <div className="sdg-header" id="header2-1-2">
    <div className="text-center">
<div className="badge badge-pill" style={{background: '#cecece'}}>Situación actual: imposible de realizar debido a la ausencia de un criterio numérico en la meta.</div>
<div className="badge badge-pill" style={{background: '#00a700'}}>Tendencia: mejora.</div>
    </div>
</div>
                 </div>
<p className="mt-5"><b>El nuevo acuerdo sobre biodiversidad vuelve a llamar la atención sobre la participación justa y equitativa en los beneficios derivados de la utilización de los recursos genéticos.</b></p>
<p>Desde que el Protocolo de Nagoya sobre Acceso a los Recursos Genéticos y Participación Justa y Equitativa en los Beneficios derivados de su Utilización al Convenio sobre la Diversidad Biológica entró en vigor en 2014, el número de Partes que lo han ratificado ha ascendido a 138, incluidos 137 países y la Unión Europea, lo que representa el 70 % de todas las Partes en el Convenio sobre la Diversidad Biológica.</p>
<p>Sin embargo, a medida que el Protocolo de Nagoya avanza hacia su ratificación mundial, muchos países aún no han establecido las medidas legislativas, administrativas o normativas necesarias para garantizar la participación justa y equitativa en los beneficios derivados del uso de los recursos genéticos y los conocimientos tradicionales conexos. En 2022, ningún otro país había publicado ninguna medida en el Centro de Intercambio de Información sobre Acceso y Participación en los Beneficios, con lo que el número se mantiene en 68 desde 2021. Un total de 25 países han expedido 4 440 certificados de cumplimiento reconocidos internacionalmente (un aumento de 1 000) como prueba de que se concedió el consentimiento informado previo y se establecieron condiciones mutuamente acordadas para el acceso en 2022.</p>
<p>El número de Partes Contratantes en el Tratado Internacional sobre los Recursos Fitogenéticos para la Alimentación y la Agricultura (Tratado Internacional sobre sobre los Recursos Fitogenéticos) ha alcanzado la cifra de 150, incluida la Unión Europea, a partir del 1 de enero de 2023, con la adhesión de dos países en 2022. A finales de 2022, 88 países habían presentado su informe nacional para proporcionar información sobre su aplicación de las disposiciones del tratado, incluidas las medidas de acceso y distribución de beneficios; nueve países hicieron sus propuestas en 2022. El número de Acuerdos normalizados de transferencia de material (ANTM) también ha ido en aumento, pasando de 55 566 en 2015 a 91 352 en 2022, lo que indica que cada vez son más los usuarios que se benefician del acceso a los recursos fitogenéticos para la investigación, la reproducción animal y la capacitación.</p>
<p>Los retrasos notificados en los procesos legislativos y en la ejecución de las actividades de desarrollo de la capacidad debido a la pandemia de la COVID-19 han retrasado probablemente los progresos hacia la meta en algunos países. Por otra parte, el aumento de la digitalización de los materiales de desarrollo de la capacidad y capacitación ha sido un avance positivo para facilitar el intercambio de conocimientos.</p>
<p>El Fondo de distribución de beneficios, creado por el Órgano Rector del Tratado Internacional de Recursos Fitogenéticos, apoya proyectos que aprovechan los recursos fitogenéticos para encontrar soluciones a retos complejos relacionados con la inseguridad alimentaria y nutricional, la pérdida de biodiversidad y el cambio climático. Su quinto ciclo se inició en mayo de 2022. El Fondo de distribución de beneficios es el mecanismo operativo para compartir los beneficios derivados del Sistema multilateral del Tratado Internacional sobre los Recursos Fitogenéticos y su financiación incluye los ingresos procedentes de los usuarios del Sistema multilateral, además de las contribuciones voluntarias.</p>
<p>La adopción, en diciembre de 2022, del Marco mundial Kunming-Montreal de la diversidad biológica en Montreal, así como la decisión de la Conferencia de las Partes en el Convenio sobre la Diversidad Biológica de compartir de forma justa y equitativa los beneficios derivados del uso de información de secuencias digitales sobre recursos genéticos, hacen que se preste una mayor atención a la aplicación de los marcos de acceso y participación en los beneficios. En el contexto de este Marco, un Grupo especial de expertos técnicos desarrollará nuevos indicadores de acceso y participación en los beneficios relativos al Objetivo C y la meta 13. Esto brinda una importante oportunidad para seguir mejorando la recopilación y el análisis de datos sobre los beneficios compartidos derivados de la utilización de los recursos genéticos, para acelerar los esfuerzos mundiales de conservación y utilización sostenible de los recursos genéticos, así como para mejorar la aplicación mutua de los instrumentos de acceso y participación en los beneficios.</p>
 </Container>
	                <ContainerChart
                title="Figura 81. Número de acuerdos normalizados de transferencia de material con respecto a los recursos fitogenéticos para la alimentación y la agricultura en el mundo (2012-2022)"
                legend={[
                    {title: 'Australia y Nueva Zelandia', color: '#5b9bd6', customCSSClass: 'half-width'},
                    {title: 'Asia oriental y sudoriental', color: '#ed7e31', customCSSClass: 'half-width'},
                    {title: 'Asia central y meridional', color: '#a6a5a4', customCSSClass: 'half-width'},
                    {title: 'América Latina y el Caribe', color: '#ffbf00', customCSSClass: 'half-width'},
                    {title: 'África septentrional', color: '#4372c4', customCSSClass: 'half-width'},
                    {title: 'Oceanía (excluidas Australia y Nueva Zelandia)', color: '#71ad49', customCSSClass: 'half-width'},
                    {title: 'África subsahariana', color: '#265e91', customCSSClass: 'half-width'},
                    {title: 'Asia occidental', color: '#9e480e', customCSSClass: 'half-width'},
                    {title: 'Europa y América septentrional', color: '#636363', customCSSClass: 'half-width'},
                    {title: 'Mundo', color: '#9b7200', customCSSClass: 'half-width'},
                ]}
			 note={<span><b>Fuente:</b> FAO. 2023. Datos. En: <i>Portal de datos de indicadores de los ODS</i>. Roma. [Consultado el 8 de junio de 2023]. <a href="https://www.fao.org/sustainable-development-goals-data-portal/data/es">https://www.fao.org/sustainable-development-goals-data-portal/data/es</a></span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure81}
                />
            </ContainerChart>


<Container>
<b>Referencias</b>
<p><b>Agencia Espacial Europea (ESA).</b> 2017. <i>Land Cover CCI Product. User guide version 2.0</i>. Roma, FAO. [Consultado el 8 de junio de 2023]. <a href="https://maps.elie.ucl.ac.be/CCI/viewer/download/ESACCI-LC-Ph2-PUGv2_2.0.pdf">https://maps.elie.ucl.ac.be/CCI/viewer/download/ESACCI-LC-Ph2-PUGv2_2.0.pdf</a></p>
<p><b>Körner, C., Paulsen, J. y Spehn, E.</b> 2011. A definition of mountains and their bioclimatic belts for global comparisons of biodiversity data. <i>Alpine Botany</i>, 121: 73-78.</p>
				 <br /><br />
            <div className="footnotes">
            <p id="footnote8"><sup>8</sup> La responsabilidad del indicador 15.3.1 corresponde a la Convención de las Naciones Unidas de Lucha contra la Desertificación (CLD). La FAO es un organismo contribuyente.</p>
	    <p id="footnote9"><sup>9</sup> Estos valores deben interpretarse con cautela, dado que los cambios en la superficie de nieve y hielo permanentes aún no están recogidos en el conjunto de datos mundial sobre la cobertura del suelo utilizado para el análisis (Agencia Espacial Europea, 2017).</p>
	    <p id="footnote10"><sup>10</sup> La responsabilidad del indicador 15.6.1 de los ODS corresponde a la Secretaría del Convenio sobre la Diversidad Biológica (CDB). La FAO es un organismo contribuyente.</p>
	    </div>
            </Container>

        </React.Fragment>
    )
}


export default Sdg15;

